<template>
  <div>
    <div class="container mb-48">
      <AccountWidget />
      <div class="bg-gray rounded-t-md shadow relative z-50 mt-2 py-1">
        <div class="text-center relative">
          <router-link
            :to="{name: 'START'}"
            class="absolute top-0 left-0 ml-6 mt-1 hover-animate"
          >
            <BackIcon />
          </router-link>
          <h2 class="mt-5 text-base sm:text-2xl font-semibold uppercase text-primary">
            {{ $t('start.title') }}
          </h2>
          <h3 class="text-sm sm:text-base text-black-display mt-1 mb-6">
            {{ $t('order.subheading') }}
          </h3>
        </div>
      </div>
      <transition name="slide-down">
        <div
          id="step-1"
          class="relative z-50 bg-gray animate"
        >
          <div class="text-center border-t border-purple-gray relative">
            <div class="pb-12 pt-3 px-3 md:px-9">
              <Step1
                :key="id"
                :active-step="activeStep"
                @changeStep="changeStep($event)"
              />
            </div>
          </div>
        </div>
      </transition>
      <transition name="slide-down">
        <div v-if="activeStep >= 2">
          <div
            id="step-2"
            :class="{'rounded-b-md': activeStep === 1}"
            class="relative z-50 bg-gray animate"
          >
            <div class="text-center border-t border-purple-gray relative">
              <div class="pb-12 pt-3 px-3 md:px-9">
                <Step2
                  :key="id"
                  :active-step="activeStep"
                  @changeStep="changeStep($event)"
                />
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="slide-down">
        <div v-if="activeStep >= 3">
          <div class="z-40 relative animate">
            <div
              id="step-3"
              class="bg-gray animate"
            >
              <div class="text-center border-t border-purple-gray relative">
                <div
                  :class="{'pb-12': activeStep == 3}"
                  class="pb-3 pt-3 px-1 md:px-7 animate duration-700"
                >
                  <Step3
                    :active-step="activeStep"
                    @changeStep="changeStep($event)"
                  />
                </div>
              </div>
            </div>
          </div>
          <transition-expand>
            <div
              v-if="activeStep >= 4"
              class="z-30 relative animate"
            >
              <div
                id="step-4"
                class="bg-gray animate"
              >
                <div class="text-center border-t border-purple-gray relative">
                  <div class="pb-8 pt-8 px-3 md:px-9">
                    <Step4
                      :active-step="activeStep"
                      @changeStep="changeStep($event)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </transition-expand>
          <div
            v-if="activeStep >= 3"
            class="z-20 relative animate"
          >
            <div
              id="step-5"
              :class="{'rounded-b-md': activeStep >= 3}"
              class="bg-gray animate"
            >
              <div class="text-center border-t border-purple-gray relative">
                <div class="pb-12 pt-3 px-3 md:px-9">
                  <Step5
                    :active-step="activeStep"
                    @changeStep="changeStep($event)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Step1 from '@/components/Step/Step1';
import Step2 from '@/components/Step/Step2';
import Step3 from '@/components/Step/Step3';
import Step4 from '@/components/Step/Step4';
import Step5 from '@/components/Step/Step5';
import AccountWidget from '@/components/AccountWidget';
import BackIcon from '@/assets/icons/back.svg';
import TransitionExpand from '@/components/TransitionExpand';

export default {
  name: 'Order',
  components: {
    AccountWidget,
    BackIcon,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    TransitionExpand,
  },
  data() {
    return {
      loaded: false,
      activeStep: 1,
      apiData: null,
    };
  },
  computed: {
    ...mapState('order', ['categories', 'subcategories', 'bonuses', 'reset', 'id']),
  },
  methods: {
    changeStep(stepNumber) {
      this.activeStep = stepNumber;
    },
  },
};
</script>
<style lang="scss">
.hover-animate {
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: rotate(-15deg);
  }
}
</style>
